export default {
  components: {},

  data() {
    return {}
  },

  created() {
    // this.$store.dispatch('auth/setSecretCode', this.$route.query['code'])
  },
}



// WEBPACK FOOTER //
// ./src/views/auth/twitter_confirm.ctrl.js